<template>
  <span>
    <div
      v-if="data.length"
      class="pt-1"
    >
      <p class="text-center text-primary">
        Processing Office Performance
      </p>
      <apexchart
        type="bar"
        :height="chartHeight"
        :options="chartOptions"
        :series="seriesData"
      />
    </div>
    <div v-else>
      <p class="py-2 text-center text-primary">
        No data yet!
      </p>
    </div>
  </span>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chartHeight() {
      return Math.max(300, this.data.length * 32)
    },
    categoriesData() {
      return this.data.map(item => (item.name === null ? 'Unknown / not set' : item.name))
    },
    seriesData() {
      return [{ data: this.data.map(item => item.total), name: 'Applications' }]
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 2,
          },
        },
        colors: ['#d4526e'],
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: this.categoriesData,
        },
        tooltip: {
          theme: 'dark',
        },
      }
    },
  },
}
</script>
